<template>
  <div class="settings">
    <!--顶部导航-->
    <Navbar title="设置" />
    <!--内容区域-->
    <div class="content">
      <!--设置列表-->
      <settingListField :list="settingList" />
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/navbar/index.vue";
import settingListField from "@/components/settings/settingList.vue";
import { settingList } from "@/utils/const";

export default {
  name: "Settings",
  components: {
    Navbar,
    settingListField,
  },
  data() {
    return {
      settingList,
    };
  },
  async mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.settings {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background: #f4f4f4;
  background-size: 100% 30%;
  background-repeat: no-repeat;
}
</style>
